import Vue from 'vue';
import Router from 'vue-router';
/* eslint-disable */
// Pages
import Login from '@/components/pages/home/login/index.vue';
import sendCode from '@/components/pages/home/send-code/index.vue';
import changePassword from '@/components/pages/home/change-password/index.vue';
import Register from '@/components/pages/home/register/index.vue';
import Webapp from '@/components/pages/webapp/index.vue';
import Home from '@/components/pages/webapp/home/index.vue';
import Dashboard from '@/components/pages/webapp/dashboard/index.vue';
import Report from '@/components/pages/webapp/report/index.vue';
import EmplacamentoNacional from '@/components/pages/webapp/report/emplacamento-nacional.vue';
import VeiculosUsados from '@/components/pages/webapp/report/veiculos-usados.vue';
import EstoqueRede from '@/components/pages/webapp/report/estoque-rede.vue';
import MeuEstoque from '@/components/pages/webapp/my-stock/index.vue';
import EstoqueVirtual from '@/components/pages/webapp/virtual-stock/index.vue';
import EstoqueOfertaProcura from '@/components/pages/webapp/stock-supply-demand/index.vue';
import Users from '@/components/pages/webapp/users/index.vue';
import EditUser from '@/components/pages/webapp/users/edit-user/index.vue';
import AnalyticalPlates from '@/components/pages/webapp/analytical-plates/index.vue';
import Logs from '@/components/pages/webapp/page-logs/index.vue';
import Procura from '@/components/pages/webapp/procura/index.vue';
import EnriquecimentoBaixarDados from
  '@/components/pages/webapp/enriquecimento-baixar-dados/index.vue';
import ChassiEspecifico from '@/components/pages/webapp/chassi-especifico/index.vue';
import RelatorioSfat from '@/components/pages/webapp/report/relatorio-sfat.vue';
import Desenvolvimento from '@/components/pages/webapp/developing/index.vue';
import RetiradasRede from '@/components/pages/webapp/report/retiradas-rede.vue';
import Varejo from '@/components/pages/webapp/report/varejo.vue';
import FrotaCirculante from '@/components/pages/webapp/report/frota-circulante.vue';
import PotencialPecas from '@/components/pages/webapp/report/potencial-pecas.vue';
import PotencialServicos from '@/components/pages/webapp/report/potencial-servicos.vue';
import PotencialLubrificantes from '@/components/pages/webapp/report/potencial-lubrificantes.vue';
// import DashboardS24h from '@/components/pages/webapp/report/dashboard-s24h.vue';
import ListaPrecos from '@/components/pages/webapp/report/lista-precos.vue';
import MarketplacePecas from '@/components/pages/webapp/report/mkt-pecas.vue';
// import TorreControle from '@/components/pages/webapp/report/torre-controle.vue';
import AcoesCampo from '@/components/pages/webapp/report/acoes-campo.vue';
import AtivacaoConectividade from '@/components/pages/webapp/report/ativacao-conectividade.vue';
import Mef from '@/components/pages/webapp/report/mef.vue';
import Retencao from '@/components/pages/webapp/report/retencao.vue';
// import DimensionamenTool from '@/components/pages/webapp/report/dimensionamentool.vue';
import TrocaRapida from '@/components/pages/webapp/report/troca-rapida.vue';
import Sso from '@/components/pages/home/sso/index.vue';
import PrecosComparativo from '@/components/pages/webapp/report/precos-comparativo.vue';
import DisponibilidadePecas from '@/components/pages/webapp/report/disponibilidade-pecas.vue';
Vue.use(Router);

export default new Router({
  mode: 'history',
  history: true,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Login,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/sso/:token',
      name: 'sso',
      component: Sso,
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: sendCode,
    },
    {
      path: '/change-password/:email',
      name: 'ChangePassword',
      component: changePassword,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/procura/:id/:operation',
      name: 'procura',
      component: Procura,
    },
    {
      path: '/app',
      name: 'webapp',
      component: Webapp,
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home,
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: '/emplacamentos',
          name: 'Report',
          component: Report,
        },
        {
          path: '/emplacamento-nacional',
          name: 'EmplacamentoNacional',
          component: EmplacamentoNacional,
        },
        {
          path: '/veiculos-usados',
          name: 'VeiculosUsados',
          component: VeiculosUsados,
        },
        {
          path: '/estoque-rede',
          name: 'EstoqueRede',
          component: EstoqueRede,
        },
        {
          path: '/relatorio-sfat',
          name: 'RelatorioSfat',
          component: RelatorioSfat,
        },
        {
          path: '/meu-estoque',
          name: 'MeuEstoque',
          component: MeuEstoque,
        },
        {
          path: '/estoque-virtual',
          name: 'EstoqueVirtual',
          component: EstoqueVirtual,
        },
        {
          path: '/estoque-oferta-procura',
          name: 'EstoqueOfertaProcura',
          component: EstoqueOfertaProcura,
        },
        {
          path: '/retiradas-rede',
          name: 'RetiradasRede',
          component: RetiradasRede,
        },
        {
          path: '/varejo',
          name: 'Varejo',
          component: Varejo,
        },
        {
          path: '/frota-circulante',
          name: 'FrotaCirculante',
          component: FrotaCirculante,
        },
        {
          path: '/precos-comparativo',
          name: 'PrecosComparativo',
          component: PrecosComparativo,
        },
        {
          path: '/mef',
          name: 'MEF',
          component: Mef,
        },
        {
          path: '/retencao',
          name: 'Retencao',
          component: Retencao,
        },
        {
          path: '/potencial-pecas',
          name: 'PotencialPecas',
          component: PotencialPecas,
        },
        {
          path: '/potencial-servicos',
          name: 'PotencialServicos',
          component: PotencialServicos,
        },
        {
          path: '/potencial-lubrificantes',
          name: 'PotencialLubrificantes',
          component: PotencialLubrificantes,
        },
        /*
        {
          path: '/dashboard-s24h',
          name: 'DashboardS24h',
          component: DashboardS24h,
        },
        */
        {
          path: '/lista-precos',
          name: 'ListaPrecos',
          component: ListaPrecos,
        },
        {
          path: '/mkt-pecas',
          name: 'MarketplacePecas',
          component: MarketplacePecas,
        },
        /*
        {
          path: '/torre-controle',
          name: 'TorreControle',
          component: TorreControle,
        },
        */
        {
          path: '/acoes-campo',
          name: 'AcoesCampo',
          component: AcoesCampo,
        },
        {
          path: '/ativacao-conectividade',
          name: 'AtivacaoConectividade',
          component: AtivacaoConectividade,
        },
        {
          path: '/disponibilidade-pecas',
          name: 'DisponibilidadePecas',
          component: DisponibilidadePecas,
        },
        /*
        {
          path: '/dimensionamentool',
          name: 'DimensionamenTool',
          component: DimensionamenTool,
        },
        */
        {
          path: '/troca-rapida',
          name: 'TrocaRapida',
          component: TrocaRapida,
        },
        {
          path: '/users',
          name: 'Users',
          component: Users,
        },
        {
          path: '/users/:id',
          name: 'Edit User',
          component: EditUser,
        },
        {
          path: '/analytical-plates',
          name: 'AnalyticalPlates',
          component: AnalyticalPlates,
        },
        {
          path: '/list-logs',
          name: 'LogsAccess',
          component: Logs,
        },
        {
          path: '/enriquecimento-baixar-dados',
          name: 'EnriquecimentoBaixarDados',
          component: EnriquecimentoBaixarDados,
        },
        {
          path: '/chassi-especifico',
          name: 'ChassiEspecifico',
          component: ChassiEspecifico,
        },
        {
          path: '/desenvolvimento',
          name: 'Desenvolvimento',
          component: Desenvolvimento,
        },
      ],
    },
  ],
});
